<template>
  <div class="wow-aside-container">
    <div class="flex aside-icon" @click="handleClickWow">
      <img
        src="https://wowsite.musicwow.com/teaching_system_frontend/images/musicwow-logo-s.png"
        width="86px"
        height="52px"
      />
    </div>
    <div class="gray-92 font-size-16 aside-title">WOW学院</div>
    <div class="aside-search">
      <el-input
        v-model="searchInfo.keyword"
        placeholder="搜索"
        prefix-icon="el-icon-search"
        @focus="handleSearchFocus"
        readonly
      ></el-input>
    </div>
    <div class="aside-menu">
      <div class="flex menu-item menu-home" @click="backHome">
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/home.png"
          class="menu-icon"
        />
        <div class="gray-92 font-size-14 menu menu-label">主页</div>
      </div>
      <div class="flex menu-item">
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/directory.png"
          class="menu-icon directory-icon"
        />
        <div class="gray-92 font-size-14 menu-label">目录</div>
        <!-- <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/location.png"
          class="menu-icon meun-function-icon"
          @click="handleLocation"
        /> -->
        <!-- <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/expand-true.png"
          class="menu-icon meun-function-icon"
          v-if="!isExpandAll"
          @click="handleTreeExpand"
        />
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/expend-false.png"
          class="menu-icon meun-function-icon"
          v-if="isExpandAll"
          @click="handleTreeExpand"
        /> -->
        <!-- <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/scale.png"
          class="menu-icon meun-function-icon"
        /> -->
      </div>
      <div id="wow-school-aside-tree-wrap">
        <el-tree
          ref="menuTree"
          :data="treeData"
          :props="defaultProps"
          node-key="catalog_id"
          class="menu-tree"
          :expand-on-click-node="true"
        >
          <div
            slot-scope="{ node, data }"
            class="tree-item"
            :id="'wow-school-aside-tree-item-' + data.uuid"
          >
            <img
              class="doc-icon"
              v-if="data.doc_id"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/category.png"
            />
            <span
              :style="curUuid === data.uuid ? 'color:#45b13b' : ''"
              @click="handleNodeClick(data)"
              >{{ node.label }}</span
            >
          </div>
        </el-tree>
      </div>
      <div class="bottom-version">版本：{{ currentVersion }}</div>
    </div>
    <!-- 搜索弹窗 -->
    <search-dialog-com
      :visible.sync="searchDialogVisible"
      @change="handleLocation"
    >
    </search-dialog-com>
  </div>
</template>
<script>
import searchDialogCom from "./searchDialog.vue";
import { getCatalogTreeApi } from "@/api/wow";
import eventBus from "@/utils/bus";
export default {
  components: {
    searchDialogCom,
  },
  data() {
    return {
      searchInfo: {
        keyword: "",
      },
      treeData: [],
      defaultProps: {
        children: "children_directory_tree",
        label: "name",
      },
      isExpandAll: false, // 是否展开菜单
      searchDialogVisible: false, // 搜索弹窗
      curUuid: "",
      currentVersion: "",
    };
  },
  watch: {
    $route() {
      if (this.$route.name !== "materialLibraryDetail") {
        this.curUuid = "";
      }
    },
  },
  created() {
    this.getList();
    if (this.$route.name === "materialLibraryDetail") {
      this.curUuid = this.$route.query.catalog_uuid;
    }
    eventBus.$on("material-library-aside-location", (data) => {
      this.handleLocation(data);
    });
    eventBus.$on("material-library-aside-refresh", (data) => {
      this.curUuid = data;
      this.getList();
    });
  },
  beforeDestroy() {
    eventBus.$off("material-library-aside-location");
    eventBus.$off("material-library-aside-refresh");
  },
  methods: {
    getList() {
      getCatalogTreeApi().then((res) => {
        if (res.error_code === 0) {
          this.treeData = res.data.list;
          this.currentVersion = res.data.version_no;
        }
      });
    },
    handleNodeClick(...data) {
      this.curUuid = data[0].uuid;
      if (data[0].node_type === 2) {
        // 跳转文档详情
        this.$router.push({
          name: "materialLibraryDetail",
          query: {
            catalog_uuid: data[0].uuid,
          },
        });
      }
    },
    handleSearchFocus() {
      this.searchDialogVisible = true;
    },
    handleLocation(data) {
      //data:type类型，catalog_uuid路径id
      this.curUuid = data.catalog_uuid;
      // 展开目录，定位
      for (let i in this.$refs.menuTree.store.nodesMap) {
        this.$refs.menuTree.store.nodesMap[i].expanded = true;
      }
      // 无法正常scrollTo，先设置个延迟
      setTimeout(() => {
        let wrap = document.getElementById("wow-school-aside-tree-wrap");
        let els = wrap.querySelectorAll(".tree-item");
        let resH = 0;
        let itemH = 31;
        for (let i = 0; i < els.length; i++) {
          resH = resH + itemH;
          if (els[i].id === "wow-school-aside-tree-item-" + data.catalog_uuid) {
            wrap.scrollTo(0, resH);
            this.curUuid = data.catalog_uuid;
            break;
          }
        }
      }, 300);
      if (data.type === "doc") {
        // 跳转文档
        this.$router.push({
          name: "materialLibraryDetail",
          query: {
            catalog_uuid: data.catalog_uuid,
          },
        });
      }
      if (data.type === "attach") {
        // 跳转文章并定位
        this.$router.push({
          name: "materialLibraryDetail",
          query: {
            catalog_uuid: data.catalog_uuid,
            attach_uuid: data.attach_uuid,
          },
        });
      }
    },
    handleClickWow() {
      this.$router.push({
        name: "dashboard",
      });
    },
    // 展开/收起菜单，一定需要为 el-tree 添加 node-key 属性
    handleTreeExpand() {
      this.isExpandAll = !this.isExpandAll;
      this.$refs["menuTree"].store._getAllNodes().forEach((item) => {
        item.expanded = this.isExpandAll;
      });
    },
    backHome() {
      this.$router.push({
        name: "materialLibraryList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wow-aside-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  // border-right: 1px solid rgba(231, 232, 234, 1);
  .aside-icon {
    height: 74px;
    justify-content: center;
    border-bottom: 1px solid rgba(231, 232, 234, 1);
    cursor: pointer;
  }
  .aside-title {
    height: 41px;
    padding: 0 0 0 18px;
    line-height: 41px;
    font-size: 16px;
    color: #5c5d5e;
  }
  /deep/.aside-search {
    height: 28px;
    padding: 4px 8px 12px 8px;
    .el-input {
      height: 28px;
      .el-input__inner {
        height: 28px;
        border-radius: 4px;
      }
      .el-input__icon {
        line-height: 28px !important;
      }
    }
  }
  /deep/.aside-menu {
    flex: 1;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .menu-item {
      padding: 11px;
      .menu-icon {
        margin-right: 7px;
        width: 14px;
        height: 14px;
      }

      .menu-label {
        flex: 1;
      }
      .directory-icon {
        width: 12px;
      }
      .meun-function-icon {
        margin-left: 18px;
        cursor: pointer;
      }
    }
    .menu-home {
      border-radius: 4px;
      cursor: pointer;
    }
    #wow-school-aside-tree-wrap {
      flex: 1;
      height: 0;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      &::-webkit-scrollbar-button {
      }
      .menu-tree {
        padding: 0 5px;
        .el-tree-node__expand-icon {
          color: #8c8d8e;
          &.is-leaf {
            color: transparent;
          }
        }
        .tree-item {
          display: flex;
          flex: 1;
          width: 0;
          overflow: hidden;
          align-items: center;
          .doc-icon {
            width: 12px;
            margin-right: 6px;
          }
          span {
            flex: 1;
            width: 0;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 26px;
            color: #5c5d5e;
          }
        }
        .el-tree-node {
          .el-tree-node__content {
            margin: 5px 0;
            overflow: hidden;
            .el-tree-node__children {
              margin: 5px 0;
            }
            .el-tree-node__label {
              overflow: hidden;
              text-overflow: ellipsis;
              word-wrap: break-word;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              display: inline-block;
              padding-right: 6px;
            }
          }
        }
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.gray-92 {
  color: rgba(92, 93, 94, 1);
}
.gray-140 {
  color: rgba(140, 141, 142, 1);
}
.font-size-16 {
  font-size: 16px;
}
.font-size-14 {
  font-size: 14px;
}
.bottom-version {
  line-height: 36px;
  font-size: 12px;
  color: #5c5d5e;
  text-align: center;
  background: #fff;
}
</style>
